export default __webpack_public_path__ + "static/media/ada.a3488504.png";